/**
 * Class representing a construction (kouji) location.
 */
class KoujiLocation {
    /**
     * Create a kouji location.
     * @param {Object} data - Location data
     * @param {string} data.id - Location ID
     * @param {string} data.name - Location name
     * @param {Array} data.coord - Coordinates in [longitude, latitude] format
     * @param {string} data.status - Status (UNDER_CONSTRUCTION or COMPLETE)
     * @param {string|null} [data.koujiBangou=null] - Construction number
     * @param {string|null} [data.koujiName=null] - Construction name
     * @param {string|null} [data.summary=null] - Summary text
     */
    constructor({id, name, coord, status, koujiBangou = null, koujiName = null, summary = null}) {
        const me = this;

        me.id = id;
        me.name = name;
        me.coord = coord;
        me.status = status;
        me.koujiBangou = koujiBangou;
        me.koujiName = koujiName;
        me.summary = summary;
        me.type = 'kouji-location';
    }

    /**
     * Update location data.
     * @param {Object} data - Update data
     */
    update(data) {
        const me = this;

        if (data.coord) me.coord = data.coord;
        if (data.status) me.status = data.status;
        if (data.name) me.name = data.name;
        if (data.koujiBangou !== undefined) me.koujiBangou = data.koujiBangou;
        if (data.koujiName !== undefined) me.koujiName = data.koujiName;
        if (data.summary !== undefined) me.summary = data.summary;
    }
}

export default KoujiLocation;
